// 旧APIが再送間隔を返さない場合のフォールバック（秒）。通常はAPIのretry_afterを優先する。
export const RESEND_COOLDOWN_SECONDS = 60;

// 認証コードの桁数（API の SecureRandom.random_number(100000..999999) に合わせる）
export const SMS_AUTH_CODE_LENGTH = 6;
